import {ApolloClient, gql, NormalizedCacheObject} from "@apollo/client";

import {PiecesQuery, PiecesQueryVariables} from "@/graphql/types";

// Return all the pieces for a given ensemble
export default async function getPieces(client: ApolloClient<NormalizedCacheObject>, ensembleId: number) {
  const response = await client.query<PiecesQuery, PiecesQueryVariables>({
    query: gql`
      query PiecesQuery($ensembleId: Int!) {
        pieces(where: {choir_id: {_eq: $ensembleId}, deleted: {_eq: false}, active_version: {_eq: true}}) {
          id
          folder
          title
          composer
          language
          status
          error
          catalog_piece_id
          versioned_piece_id
          created_at
          parts {
            id
            name
            audio
          }
        }
      }
    `,
    variables: {ensembleId: ensembleId},
  });
  return response.data?.pieces;
}
